
























































import { Component, Vue, Inject, Prop, Watch, Mixins } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import ListMixin from "@/components/mixin/list-mixin";
import EditConfig from "./edit-config.vue";

@Component({
  components: { EditConfig }
})
export default class Users extends Mixins(AbpBase, ListMixin) {
  keyword: string = "";
  namespace = "config";
  get store () {
    return this.$store.state.config;
  }
  columns = [
    {
      title: this.L("Name"),
      key: "name"
    },
    {
      title: this.L("Value"),
      key: "value"
    },
    {
      title: this.L("Action"),
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small"
              },
              style: {
                marginRight: "5px"
              },
              on: {
                click: async () => {
                  this.edit(params.index);
                }
              }
            },
            this.L("Edit")
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small"
              },
              on: {
                click: async () => {
                  this.remove(params.index)
                }
              }
            },
            this.L("Delete")
          )
        ]);
      }
    }
  ];
}
